export enum EUserStatus {
  ACTIVE = "active",
  DEACTIVATED = "deactivated",
  HIDDEN = "hidden",
  BANNED = "banned",
  TEMPORARY_BANNED = "temporary_banned",
  SILENT_BANNED = "silent_banned"
}
